export const FAILED_GET_COMPETITION = 'FAILED_GET_COMPETITION'
export const FAILED_GET_COMPETITIONS = 'FAILED_GET_COMPETITIONS'
export const RECEIVE_GET_COMPETITION = 'RECEIVE_GET_COMPETITION'
export const RECEIVE_GET_COMPETITIONS = 'RECEIVE_GET_COMPETITIONS'
export const REQUEST_GET_COMPETITION = 'REQUEST_GET_COMPETITION'
export const REQUEST_GET_COMPETITIONS = 'REQUEST_GET_COMPETITIONS'
